module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/2_e2bcff01b11369337cc562c66b75ebbc.png";